import React from 'react';
import { useTranslation } from 'react-i18next';
import { SIMULATION_FINISHED_DELAY_MS } from 'Utils';
import { shouldShowSimulations } from 'Selectors';
import { RoleService } from 'Services';
import useIsSimulating from 'Hooks/useIsSimulating';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';

const BackgroundProcessContainer = () => {
    const { addAlert } = useAlertBanner();
    const { t } = useTranslation();

    const onSuccess = () => {
        setTimeout(() => {
            addAlert({
                id: 'simulation-success',
                content: t('SimulationSuccessAlertText'),
                status: 'success'
            });
        }, SIMULATION_FINISHED_DELAY_MS);
    };

    const onError = () => {
        addAlert({
            id: 'simnulation-error',
            status: 'danger',
            content: t('SimulationErrorAlertText')
        });
    };

    // check if any simulation created by the current user is in queue or finished
    // if any in queue, keep tracking
    // if featureFlag is turned off or the user doesn't have access to simulations, don't track
    const canAccessSimulations = RoleService.hasDesignAccess;
    useIsSimulating(shouldShowSimulations() && canAccessSimulations, onSuccess, onError);

    return <></>;
};

export default BackgroundProcessContainer;
